import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Heading } from "../../components";
import { ResumeContext } from "../../contexts/resumeContext";
import {
  Check,
  ChevronLeft,
  ChevronRight,
  CloudDownload,
  Download,
} from "../../components/Icons/Icons";
import { downloadPdf, printPdf } from "../../utils";
import styles from "./previewbar.module.css";
import { templates } from "../../utils/constants";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { UserContext } from "../../contexts/userContext";

const fontSizeOptions = [
  { size: "10px", label: "Extra Small" },
  { size: "11px", label: "Small" },
  { size: "12px", label: "Medium" },
  { size: "13px", label: "Large" },
  { size: "14px", label: "Extra Large" },
];

function PreviewBar({ toggleUpgradeModal, togglePreviewBar }) {
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(false)

  const { user } = useContext(UserContext);
  const {
    colorOptions,
    setActiveColor,
    setActiveFontSize,
    activeFontSize,
    activeColor,
    setActiveDesign,
    activeDesign,
    resumeInfo,
    documentRef,
    documentDataRef
  } = useContext(ResumeContext);

  const handleClose = (e) => {
    const ele = document.querySelector(`.${styles.previewBar}`)
    if(!ele?.contains(e.target)){
      togglePreviewBar?.()
    }
  }

  useEffect(() => {
    window.addEventListener('click', handleClose)

    return () => window.removeEventListener('click', handleClose)
  }, [])

  console.log('preboewBar', resumeInfo, documentRef, documentDataRef)

  const handleScroll = (scroll) => {
    [...document.querySelectorAll(`.${styles.designWrapper}`)].map(
      (item) => (item.scrollLeft += scroll)
    );
  };

  const updateDocData = async () => {
    await setDoc(
      doc(db, "documents", params?.docId),
      { color: activeColor, fontSize: activeFontSize, design: activeDesign },
      { merge: true }
    );
  };

  const handleBack = () => {
    updateDocData();
    navigate(-1);
  };

  const handleDownload = (type) => {
    updateDocData();
    if (user.paid) {
      if (type === "ATS") {
        printPdf(activeDesign);
      } else {
        setLoading(true)
        downloadPdf(() => setLoading(false));
      }
    } else {
      toggleUpgradeModal(true);
    }
  };

  return (
    <div className={styles.previewBar}>
      <button className={styles.backBtn} onClick={handleBack}>
        <ChevronLeft /> Back to Editor
      </button>
      <div className={styles.section}>
        <Heading content="Choose Theme" />
        <div className={styles.colorBtns}>
          {colorOptions.map((color) => (
            <button
              disabled={color === activeColor}
              className={styles.colorBtn}
              onClick={() => setActiveColor(color)}
              style={{ background: color }}
            >
              {color === activeColor && <Check />}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.section}>
        <Heading content="Font Size" />
        <div className={styles.fontBtns}>
          {fontSizeOptions.map((size) => (
            <div className={styles.fontBtn} key={size.label}>
              <input
                type="radio"
                id={`size_${size.size}`}
                name="fontSize"
                value={size.size}
                checked={size.size === activeFontSize}
                onChange={(e) => setActiveFontSize(e.target.value)}
              />
              <label
                style={{ fontSize: size.size }}
                htmlFor={`size_${size.size}`}
              >
                {size.label}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.section}>
        <Heading content="Change Design" />
        <div className={styles.designWrapper}>
          <button
            className={`${styles.scrollBtn} ${styles.scrollBtnLeft}`}
            onClick={() => handleScroll(-250)}
          >
            <ChevronLeft />
          </button>
          {templates.map((template) => (
            <div
              className={`${styles.image} ${
                template.name === activeDesign ? styles.active : ""
              }`}
              onClick={() => setActiveDesign(template.name)}
            >
              <img src={template.img} />
              <p>{template.name}</p>
            </div>
          ))}

          <button
            className={`${styles.scrollBtn} ${styles.scrollBtnRight}`}
            onClick={() => handleScroll(250)}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
      <div className={styles.downloadBar}>
        <Button
          outlined
          data-content="Best for submitting resume online. Uses text-based engine to download pdf"
          onClick={() => handleDownload("ATS")}
          content={
            <>
              <CloudDownload /> &nbsp; Download for ATS
            </>
          }
        />
        <Button
          loading={loading}
          data-content="Best for printing resume on paper. Uses image-based engine to generate pixel perfect PDF"
          onClick={() => handleDownload()}
          content={
            <>
              <Download /> &nbsp; Download PDF
            </>
          }
        />
      </div>
    </div>
  );
}

export default PreviewBar;
